import { IconChevronRight } from '@tabler/icons-react'
import Image from 'next/image'
import { WrapperLink } from '@/components/WrapperLink'
import { RATING_LABEL, TRUSTPILOT_REVIEWS_URL } from './TrustpilotStarsBadge'
import trustpilotWordmark from '@/assets/images/refresh/trustpilot/trustpilot-wordmark.png'
import classes from './trustpilot.module.css'

const WORDMARK_WIDTH = 142
const WORDMARK_HEIGHT = 36

/** Trustpilot wordmark + reviews link (Figma 929-3853 section header). */
export function TrustpilotLogoBadge() {
    return (
        <div className={classes.logoBadge}>
            <Image
                src={trustpilotWordmark}
                alt="Trustpilot"
                width={WORDMARK_WIDTH * 2}
                height={WORDMARK_HEIGHT * 2}
                style={{ width: 'auto', height: WORDMARK_HEIGHT, display: 'block' }}
            />
            <WrapperLink
                href={TRUSTPILOT_REVIEWS_URL}
                target="_blank"
                rel="noopener noreferrer"
                openExternally
                className={classes.reviewsLink}
                aria-label={RATING_LABEL}
            >
                <span className={classes.logoRatingText}>{RATING_LABEL}</span>
                <IconChevronRight size={20} className={classes.chevron} aria-hidden />
            </WrapperLink>
        </div>
    )
}
